import listActions from 'src/modules/formTemplate/list/formTemplateListActions';
import FormTemplateService from 'src/modules/formTemplate/formTemplateService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'FORMTEMPLATE_DESTROY';

const formTemplateDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: formTemplateDestroyActions.DESTROY_STARTED,
      });

      await FormTemplateService.destroyAll([id]);

      dispatch({
        type: formTemplateDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.formTemplate.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/form-template');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: formTemplateDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: formTemplateDestroyActions.DESTROY_ALL_STARTED,
      });

      await FormTemplateService.destroyAll(ids);

      dispatch({
        type: formTemplateDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.formTemplate.destroyAll.success'),
      );

      getHistory().push('/form-template');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: formTemplateDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default formTemplateDestroyActions;
